import { type ServiceMethod } from '@/application/interfaces/service';

import {
  type ProductContext,
  type BaseBody,
  type BaseParams,
  type ProductPlacementKey,
} from '../model';
import { createBaseBody } from '../utils';

import adapter from './adapter';
import { type ProductAds } from './model';

export type Params = BaseParams & {
  context: ProductContext;
};

export type Body = BaseBody & {
  placements: Record<
    ProductPlacementKey,
    { quantity: number; types: ['product'] }
  >;
};

export type ExternalResponse = Record<ProductPlacementKey, ProductAds[]>;

export type Response = {
  data: ProductAds[];
};

const baseUrl = process.env.NEXT_PUBLIC_RETAIL_MEDIA_BASE_URL;
const publisherId = process.env.NEXT_PUBLIC_RETAIL_MEDIA_PUBLISHER_ID;

const getProductsAds: ServiceMethod<Response, Params> =
  (httpClient) => async (data, options) => {
    const { context, sessionId, userId, device } = data;

    const { body: response } = await httpClient.post<ExternalResponse, Body>(
      `/v1/rma/${publisherId}`,
      {
        ...options,
        body: {
          ...createBaseBody({ context, sessionId, userId, device }),
          placements: {
            [`${device}_${context.name}_${context.position}_product` satisfies ProductPlacementKey]:
              { quantity: 10, types: ['product'] },
          },
        },
        baseUrl,
      }
    );

    return adapter({ context, device, externalResponse: response });
  };

export default getProductsAds;
